import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b620cc4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-4 m-4" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl font-bold mb-6 text-center" }, "Technology Stacks", -1))
const _hoisted_3 = { class: "min-w-full table-auto border-collapse border border-gray-300" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "border border-gray-300 p-2" }, "Name", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "border border-gray-300 p-2" }, "Description", -1))
const _hoisted_6 = {
  key: 0,
  class: "border border-gray-300 p-2"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "border border-gray-300 p-2" }, "When to Choose", -1))
const _hoisted_8 = { class: "border border-gray-300 p-2" }
const _hoisted_9 = { class: "border border-gray-300 p-2" }
const _hoisted_10 = {
  key: 0,
  class: "border border-gray-300 p-2"
}
const _hoisted_11 = { class: "border border-gray-300 p-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.technologyStacks, (category, categoryName) => {
      return (_openBlock(), _createElementBlock("section", {
        key: categoryName,
        class: "mb-10"
      }, [
        _createElementVNode("h2", {
          style: _normalizeStyle({ color: _ctx.stringToColor(categoryName) }),
          class: "text-lg font-semibold mb-4"
        }, _toDisplayString(_ctx.formatCategoryName(categoryName)), 5),
        _createElementVNode("table", _hoisted_3, [
          _createElementVNode("thead", {
            style: _normalizeStyle({ backgroundColor: _ctx.stringToColor(categoryName, 0.2) })
          }, [
            _createElementVNode("tr", null, [
              _hoisted_4,
              _hoisted_5,
              (_ctx.hasLanguage(category))
                ? (_openBlock(), _createElementBlock("th", _hoisted_6, "Language"))
                : _createCommentVNode("", true),
              _hoisted_7
            ])
          ], 4),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category, (tech) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: tech.name,
                style: _normalizeStyle({ backgroundColor: _ctx.stringToColor(categoryName, 0.1) })
              }, [
                _createElementVNode("td", _hoisted_8, _toDisplayString(tech.name), 1),
                _createElementVNode("td", _hoisted_9, _toDisplayString(tech.description), 1),
                (_ctx.hasLanguage(category))
                  ? (_openBlock(), _createElementBlock("td", _hoisted_10, _toDisplayString(tech.language), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("td", _hoisted_11, _toDisplayString(tech.whenToChoose), 1)
              ], 4))
            }), 128))
          ])
        ])
      ]))
    }), 128))
  ]))
}